import { getFiGrowthBook, useFlagsLoaded } from '../../../lib/growthbook';

/**
 * GrowthBook flag for the cat-first Fi Mini for cats page (`/shop?selected=mini&type=cat`).
 *
 * - Type: boolean. Default `false` (the current cats page).
 * - `true`: the cat-first variant - hardware tiles in the hero, cat copy on the plan card and
 *   returns tile, and its own below-fold sections (outside time, Fi vs AirTag, the cat's day in
 *   the app, cat specs, cat reviews and a cat FAQ).
 * - Who is evaluated: cats-page visitors only, once flags have loaded. Dog and lineup traffic never
 *   reads the flag, so it never enters the experiment.
 * - QA: set the cookie `fi_gb_ee_ecom-cat-first-pdp=true`.
 */
export const CAT_FIRST_PDP_FLAG = 'ecom-cat-first-pdp';

/**
 * Whether the cats page shows the cat-first variant. The flag is read only for the cats page and
 * only after flags load: main prerenders /shop before GrowthBook is ready, and an earlier read
 * would log an exposure for the control the shopper never kept seeing.
 */
export function useCatFirstPdp(isCatsPage: boolean): boolean {
  const flagsLoaded = useFlagsLoaded();
  if (!isCatsPage || !flagsLoaded) {
    return false;
  }
  return getFiGrowthBook().getFeatureValue<boolean>(CAT_FIRST_PDP_FLAG, false);
}
